module.exports = __webpack_public_path__ + "img/Location.09ad7cfd.svg";